import React, { PureComponent } from 'react';
import Sidebar from './sidebar';
import Header from './header';
import LoginView from '../login/loginview';
import { connect } from 'react-redux';
import qs from 'qs';
import $ from 'jquery'

import { autoLogin } from '../../redux/actions/authActions';

class Layout extends PureComponent {
    
    componentWillUnmount(){
        $('html').css('background-image', 'url()');
        $('#loginView').css('background-image', 'url()');
        $('#loginView').css('background-size', 'cover');
    }

    componentDidMount(){
        if (localStorage.getItem('apiToken') === null || localStorage.getItem('apiToken') === undefined) {
            $('html').css('background-image', 'url(assets/img/loginpage.png)');
            $('#loginView').css('background-image', 'url(assets/img/loginpage.png)');
            $('#loginView').css('background-size', 'cover');
            $('html').css('background-size', 'cover');

        }

        let queryString = qs.parse(window.location.search)
        let userKey = queryString["userKey"] || queryString["?userKey"] || null;
        let globalAccessToken = queryString["token"] || queryString["?token"] || null;
        if (userKey != null && globalAccessToken != null) {
            this.props.autoLogin(globalAccessToken, userKey)
        }
    }

    render() {
        return (
            <React.Fragment>
                {localStorage.getItem('apiToken') ? 
                    <>
                        <Header />
                        <Sidebar />
                        <div className="main-panel p-light-white">{this.props.children}</div>
                    </>
                    :
                    <div id="loginView"><LoginView /></div>
                }
            </React.Fragment>
        )
    }
}

export default connect(null, { autoLogin })(Layout);